import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import dayjs from 'dayjs'
import Message from './Message'
import NewThread from './NewThread'

const useStyles = makeStyles((theme) => ({
  messageList: {
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px'
  }
}))

function MessageList ({ parentInfo, messages, isNewThread, onSuggestionClick, onRetry }) {
  const classes = useStyles()
  const sortedMessages = useMemo(() => {
    return messages.sort((a, b) => {
      if (a?.createdDate && b?.createdDate) {
        return dayjs(b.createdDate).isAfter(a.createdDate) ? -1 : 1
      }
      return 0
    })
  }, [messages])

  if (isNewThread || messages.length === 0) {
    return (<NewThread onSuggestionClick={onSuggestionClick} />)
  }

  return (
    <div className={classes.messageList}>
      {sortedMessages.map((message, index) => (
        <Message
          key={message.threadMessageId || `placeholder-${index}`}
          parentInfo={parentInfo}
          message={message}
          onRetry={onRetry}
          onSuggestionClick={onSuggestionClick}
        />
      ))}
    </div>
  )
}

MessageList.propTypes = {
  parentInfo: PropTypes.shape({
    parentId: PropTypes.string,
    parentType: PropTypes.oneOf(['schedule', 'thread'])
  }),
  messages: PropTypes.arrayOf(PropTypes.object).isRequired,
  isNewThread: PropTypes.bool,
  onSuggestionClick: PropTypes.func,
  onRetry: PropTypes.func
}

export default MessageList
